import React, { useState, useEffect, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import mainImages from "../assets/1.jpeg";
export default function ProductDetails() {
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [mainImage, setMainImage] = useState(productData.product_main_image);
    const sizes = ["2-3Y", "3-4Y", "5-6Y"];
    const colors = ["#000000", "#ff0000", "#0000ff"];
    useEffect(() => {
        fetchProductData();
    }, []);
    const fetchProductData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product/7";
            const response = await makeRequest("get", url);
            if (response) {
                setProductData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const increaseQty = () => setQuantity(prev => prev + 1);
    const decreaseQty = () => {
        if (quantity > 1) setQuantity(prev => prev - 1);
    };
    const handleShare = async () => {
        const shareData = {
            title: productData.product_name,
            text: "Check out this product!",
            url: window.location.href
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData); // mobile native share
            } else {
                await navigator.clipboard.writeText(window.location.href);
                alert("Link copied to clipboard!");
            }
        } catch (err) {
            console.log("Share failed:", err);
        }
    };
    return (
        <div className="page-container">
            <Header />
            <Breadcrumb />
            <div className="product-container">
                <div className="image-section">
                    <img src={mainImages} alt="product" className="main-image" />
                    <div className="thumbnail-row">
                        <img src={productData.product_main_image} onClick={() => setMainImage(productData.product_main_image)} />
                        <img src={productData.product_guide_image} onClick={() => setMainImage(productData.product_guide_image)} />
                    </div>
                </div>
                <div className="details-section">
                    <h2>{productData.product_name}</h2>
                    <p className="brand">Brand: {productData.brand_name}</p>
                    <p className="category">{productData.maincategory_name}</p>
                    <div className="price-section">
                        <span className="price">₹{productData.product_sales_price}</span>
                        <span className="mrp">₹{productData.product_mrp_price}</span>
                    </div>
                    <div className="option-group">
                        <h4>Select Size</h4>
                        <div className="options">
                            {sizes.map((size, i) => (
                                <button
                                    key={i}
                                    className={selectedSize === size ? "active" : ""}
                                    onClick={() => setSelectedSize(size)}>{size}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="option-group">
                        <h4>Select Color</h4>
                        <div className="color-options">
                            {colors.map((color, i) => (
                                <div
                                    key={i}
                                    className={`color-circle ${selectedColor === color ? "active" : ""}`}
                                    style={{ backgroundColor: color }}
                                    onClick={() => setSelectedColor(color)} />
                            ))}
                        </div>
                    </div>
                    <div className="option-group">
                        <h4>Quantity</h4>
                        <div className="quantity-box">
                            <button onClick={decreaseQty}>-</button>
                            <span>{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div>
                    </div>
                    <div className="description">
                        <h4>Description</h4>
                        <p>{productData.product_description}</p>
                    </div>
                    <div className="action-buttons">
                        <button className="add-to-cart">
                            Add to Cart
                        </button>

                        <button className="share-btn" onClick={handleShare}>
                            Share
                        </button>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}